import React from 'react';

import AIMessage from '@/features/AIChat/AskGXDrawer/Messages/AIMessage';
import HumanMessage from '@/features/AIChat/AskGXDrawer/Messages/HumanMessage';
import { useChat } from '@/features/AIChat/context/useChat';
import { Message } from '@/features/AIChat/context/utils';

const MessageComponent = ({ msg, index }: { msg: Message; index: number }) => {
  const { isSending, version, messages } = useChat();

  const isAI = msg.sender === 'ai';
  const isLastMessage = index === messages.length - 1;

  const prevMessage = messages.at(index - 1);
  const prompt = prevMessage?.sender === 'human' ? prevMessage.text : '';

  if (isAI) {
    return (
      <AIMessage
        isLastMessage={isLastMessage}
        isSending={isSending}
        msg={msg}
        prompt={prompt}
        version={version}
      />
    );
  }
  return <HumanMessage msg={msg} />;
};
export default MessageComponent;
